
import React from 'react';
import { JUVCard } from '@/components/juv';
import { Dna } from 'lucide-react';
import TreatmentTable from './TreatmentTable';

const PeptideTherapiesSection = () => {
  const therapies = [
    {
      name: 'GLOW Stack',
      price: '$450',
      benefits: 'Anti-aging, skin/hair, recovery'
    },
    {
      name: 'Tesamorelin/Ipamorelin',
      price: '$250',
      benefits: 'Muscle, fat loss, sleep'
    },
    {
      name: 'Retatrutide',
      price: '$1,150',
      benefits: 'Advanced weight loss'
    },
    {
      name: 'NAD+',
      price: '$550',
      benefits: 'Energy, cognition, anti-inflammatory'
    },
    {
      name: 'Epithalon',
      price: '$150',
      benefits: 'Deep sleep, longevity'
    }
  ];

  const bundles = [
    {
      name: 'Skin Revitalize',
      benefits: 'Glow + Epithalon',
      price: '$549'
    },
    {
      name: 'Anti-Aging & Energy',
      benefits: 'NAD+ + Epithalon',
      price: '$649'
    },
    {
      name: 'Weight Loss & Muscle',
      benefits: 'Retatrutide + Tesa/Ipamorelin',
      price: '$699/mo or $1,299 (2 mo)'
    },
    {
      name: 'Complete Rejuvenation',
      benefits: 'Glow + Reta + Tesa/Ipa + NAD+',
      price: '$1,699/mo or $3,299 (2 mo)'
    },
    {
      name: 'Sleep Stack',
      benefits: 'Epithalon + Tesa/Ipamorelin',
      price: '$349'
    }
  ];

  return (
    <JUVCard
      title="🧬 Peptide Therapies"
      icon={Dna}
      variant="glass"
      className="mb-8"
    >
      <div className="space-y-8">
        {/* Individual Therapies */}
        <TreatmentTable
          headers={['Treatment', 'Price', 'Key Benefits']}
          treatments={therapies}
        />

        {/* Peptide Bundles */}
        <div>
          <h3 className="text-xl font-semibold text-juv-deep-chestnut mb-4">
            Peptide Bundles
          </h3>
          <TreatmentTable
            headers={['Bundle', 'Inclusions', 'Price']}
            treatments={bundles}
          />
        </div>
      </div>
    </JUVCard>
  );
};

export default PeptideTherapiesSection;
